import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, FormControl, ValidationErrors } from '@angular/forms';
import { BehaviorSubject, combineLatest, Observable, of, timer } from 'rxjs';
import { catchError, debounceTime, delay, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { CompaniesService } from '../../services/companies.service';

@Injectable({ providedIn: 'root' })
export class CompanyCodeValidator implements AsyncValidator {
	constructor(private http: HttpClient, private companiesService: CompaniesService) {}

	validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
		const companyCode = control.value;
		const httpParams = new HttpParams().set('update', '').set('current', companyCode).set('type', 'code');
		if (control.value === null || control.value.length === 0) {
			return of(null);
		}
		return timer(500).pipe(
			switchMap(() => {
				return this.companiesService.confirmCompanyInformation(httpParams).pipe(
					map((result) => {
						if (result === true) {
							return { codeInValid: true };
						} else {
							// status is valid
							return null;
						}
					})
				);
			})
		);
	}
}
